import "../chunk-PKUHTIDK.js";
const breadcrumbItemSelect = ({ emit, state, constants }) => {
  state.breadcrumbEmitter.on(constants.EVENT_NAME.breadcrumbItemSelect, (value) => {
    state.currentBreadcrumbItem = value;
    emit("select", value);
  });
};
export {
  breadcrumbItemSelect
};
